import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/**
 * Falcon's own recorded order book (`GET /orders`, ADR-032) - read-only,
 * zero arguments. Also wraps Backend v2.1's (Sprint 4.5) two strictly
 * read-only pre-trade endpoints: `previewOrder` runs the real Risk
 * Engine against a proposed order without ever submitting it;
 * `estimateOrder` reads whatever order-economics values already exist.
 * Neither call, nor anything in this workspace, ever calls an
 * order-submission endpoint.
 */
export const orderService = {
  async getOrderBook(): Promise<ApiRecord[]> {
    const response = await apiClient.get<ApiRecord[]>(endpoints.executions.orderBook);
    return response.data;
  },
  async getOrderDetail(executionId: string): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.executions.orderDetail(executionId));
    return response.data;
  },
  async previewOrder(params: OrderPreviewParams): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.executions.preview, {
      instrument_token: params.instrumentToken,
      side: params.side,
      quantity: params.quantity,
      price: params.price,
    });
    return response.data;
  },
  async estimateOrder(params: OrderEstimateParams): Promise<ApiRecord> {
    const response = await apiClient.post<ApiRecord>(endpoints.executions.estimate, {
      instrument_token: params.instrumentToken,
      quantity: params.quantity,
      price: params.price,
    });
    return response.data;
  },
};

export interface OrderPreviewParams {
  instrumentToken: string;
  side: "BUY" | "SELL";
  quantity: number;
  price?: number;
}

export interface OrderEstimateParams {
  instrumentToken: string;
  quantity: number;
  price?: number;
}
